import { useLocation } from 'react-router';

export function usePaymentId() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location!.search);
  const paymentId = queryParams.get('payment_id') as string;

  return paymentId;
}
